import './App.css';
import { useDispatch } from 'react-redux';
import fetchUserDetails from './utils/fetchUserDetails';
import { setUserDetails } from './store/userSlice';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import Header from './components/header/Header';
//import Home from './pages/home/Home';
import Movie from './pages/Movie/Movie';
import MovieList from './components/movie list/MovieList';
import Login from './pages/Login/Login';
// import Register from './pages/Register/Register';
import Register from './design/Register.js';
import Home from './LandingPage/Home.js';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import OTPVerification from './pages/OTPVerification/OTPVerification';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import MyReviews from './pages/MyReviews/MyReviews';
import Chatbox from './components/Chatbox';
import Recommendations from './pages/recommendations/recommendations';
import FriendRequests from './pages/FriendRequests/FriendRequests';
import Lists from './pages/watchlist/watchlist';
import FriendsPage from "./pages/FriendsPage.jsx";
import TrendsPage from './pages/TrendsPage/TrendsPage.jsx';
import Search from './MovieSearch/Search.js';

function App() {
  const dispatch = useDispatch()
  const fetchUser = async () => {
    const userData = await fetchUserDetails();
    //console.log("User Data:", userData.data);
    if (userData && userData.data) {
      dispatch(setUserDetails(userData.data));
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        {/* <Header /> */}
        <Routes>
          <Route index element={<Home />} />
          <Route path="movie/:id" element={<Movie/>} />
          <Route path="movies/:type" element={<MovieList/>} />
          <Route path="*" element={<h1 >Oops! You seem to have encountered an error. </h1>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/otp-verification" element={<OTPVerification/>} />
          <Route path="/reset-password" element={<ResetPassword/>} />
          <Route path ="/dashboard/myreviews" element ={<MyReviews/>} />
          <Route path ="/chat" element ={<Chatbox />} />
          <Route path ="/recommendations" element ={<Recommendations/>} />
          <Route path="/friend-requests" element={<FriendRequests />} />
          <Route path="/watchlist" element={<Lists/>} />
          <Route path="/friends" element={<FriendsPage />} />
          <Route path="/trends" element={<TrendsPage/>} />
          <Route path="/search" element={<Search/>} />
        </Routes>
        <Toaster/>
      </BrowserRouter>
    </div>
  );
}

export default App;
